import React from 'react'
import styled from '@emotion/styled'
import { JsonLd } from 'react-schemaorg'
import { object, string } from 'prop-types'

import { Header } from './Header'
import { Footer } from './Footer'
import { ArticleSchema, AuthorCard, PageWrapper } from '@jelly/components'
import { ContentBody } from '../Article/ContentBody'
import { LeftRail } from '../Category/seo/LeftRail'

const ContentBodyContainer = styled.div`
	${({ theme }) => theme.maxWidth.L};
	display: flex;
	flex-direction: row;
	margin: auto;
	margin-bottom: 4rem;
	width: 90%;

	${({ theme }) => theme.MQ.M} {
		margin-top: 2rem;
	}

	${({ theme }) => theme.MQ.XL} {
		width: 100%;
	}
`
const SubTitle = styled.h2`
	color: ${({ theme }) => theme.palette.tertiary.main};
	font-size: 1.5rem;
`
const ImageCreditContainer = styled.div`
	margin-bottom: 2rem;
	text-align: right;
`

LinkBuilding.propTypes = {
	author: object.isRequired,
	canonical: string.isRequired,
	content: string,
	lastModified: string,
	meta: object,
	published: string,
	subtitle: string,
	thumbnail: object,
	title: string,
}
/**
 * Link Building template, this template has no traditional header or footer
 * Goal of this template is to focus on driving SEO traffic to this url
 *
 * @param {Object} props.author :: object of author data
 * @param {String} props.canonical :: current canonical of the page
 * @param {String} props.content :: html content from ccm
 * @param {String} props.lastModified :: date saved from ccm
 * @param {Object} props.meta :: meta data related to the current page saved from ccm
 * @param {String} props.published :: date saved from ccm
 * @param {String} props.subtitle :: subtitle of article set in ccm
 * @param {Object} props.thumbnail :: data for thumbnail image
 * @param {String} props.title :: title of the article saved from ccm
 */
export function LinkBuilding({
	author,
	bestPicks,
	canonical,
	content,
	docType,
	lastModified,
	meta,
	published,
	parsedContent,
	thumbnail,
	subtitle,
	title,
	type = 'article',
	resource,
}) {
	return (
		<PageWrapper meta={meta}>
			<JsonLd item={ArticleSchema({ author, canonical, content, lastModified, published, title, thumbnail })} />
			<Header
				author={author}
				canonical={canonical}
				lastModified={lastModified}
				published={published}
				thumbnail={thumbnail}
				title={title}
			/>
			<ContentBodyContainer>
				{parsedContent.toc && <LeftRail docType={docType} tocElements={parsedContent.toc} />}
				<div id="top-of-toc">
					<SubTitle>{subtitle}</SubTitle>
					<ContentBody bestPicks={bestPicks} json={parsedContent.json} resource={resource} type={type} />
					{thumbnail.caption && (
						<ImageCreditContainer>Image Credit: {thumbnail.caption}</ImageCreditContainer>
					)}
					<AuthorCard author={author} />
				</div>
			</ContentBodyContainer>
			<Footer />
		</PageWrapper>
	)
}
